import React from "react";
import * as classNames from "classnames";
import styles from "./card.css";
import stylesGoogleMaps from "./cardGoogleMaps.css";
import { FavouriteIconSmall } from "../icons/icons";
import { TagList } from "../tags/tags";
import { Paragraph, SmallParagraph } from "../typography/typography";

export const googleMapsUrlRegex = RegExp("(google.com/maps/place)", "gi");

export function GoogleMapsCard(info) {
	const allClassNames = classNames(styles.card, stylesGoogleMaps.card);
	const { title, location, image, tags, data } = info;

	return (
		<a href={location.mapUrl} className={allClassNames}>
			{image ? (
				<div className={styles.image}>
					<img src={image} alt="" />
				</div>
			) : null}
			<Paragraph className={styles.cardTitle}>{title}</Paragraph>

			<div className={stylesGoogleMaps.meta}>
				{data.rating ? <Rating rating={data.rating} /> : null}
				{location.addressFormattedShort ? (
					<Meta text={location.addressFormattedShort} />
				) : null}
			</div>

			{tags ? <TagList tags={tags} /> : null}
		</a>
	);
}

const Rating = ({ rating }) => {
	return (
		<SmallParagraph className={stylesGoogleMaps.rating}>
			{rating} / 5
		</SmallParagraph>
	);
};

const Meta = ({ text }) => {
	return (
		<div className={stylesGoogleMaps.metaItem}>
			<FavouriteIconSmall className={stylesGoogleMaps.metaItemIcon} />
			<SmallParagraph className={stylesGoogleMaps.metaItemText}>
				{text}
			</SmallParagraph>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/card/cardGoogleMaps.js